import React from 'react';

import Popup from '../../Popup';

import styles from '../WelcomePopUps/welcomePopUps.scss';

class UnClaimedProfileMessagePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayCopied: false,
            displayShareUrl: false,
        };

        this.setInputRef = this.setInputRef.bind(this);
        this.copyTextToClipboard = this.copyTextToClipboard.bind(this);
        this.onCtaClick = this.onCtaClick.bind(this);
    }

    onCtaClick() {
        if (!this.state.displayShareUrl) {
            this.setState({ displayShareUrl: true });
        }
    }

    setInputRef(node) {
        this.input = node;
    }

    copyTextToClipboard(copyText, ev) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(copyText).then(() => {
                this.closePopUp(true);
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
                this.closePopUp(false);
            });
        } else {
            this.fallbackCopyText(ev);
        }
    }

    fallbackCopyText() {
        const isIphone = navigator.userAgent.match(/ipad|iphone/i);
        let linkCopied = false;
        if (this.input) {
            let range; let
                selection;
            if (isIphone) {
                range = document.createRange();
                range.selectNodeContents(this.input);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                this.input.setSelectionRange(0, 999999);
            } else {
                this.input.select();
            }
            try {
                linkCopied = document.execCommand('copy');
            } catch (err) {
                console.error(err);
            }
        }
        this.closePopUp(linkCopied);
    }

    closePopUp(linkCopied) {
        if (linkCopied) {
            this.setState({
                displayCopied: true,
            }, () => {
                setTimeout(() => {
                    this.props.onCloseClick();
                }, 1000);
            });
        } else {
            this.setState({
                displayCopied: false,
            });
        }
    }

    render() {
        const {
            onCloseClick,
            gender,
            firstname,
        } = this.props;
        const url = this.props.url || window.location.href;
        return (
            <Popup
                className={`popup-md`}
                popUpClassName={`${styles.welcomePopUp}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        Do you know {firstname}?
                    </h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <p>
                        {firstname} has not activated {gender.toLowerCase() === 'male' ? 'his' : 'her'} player profile yet. Share this profile with {firstname} so {gender.toLowerCase() === 'male' ? 'he' : 'she'} can activate it for free and understand where {gender.toLowerCase() === 'male' ? 'he' : 'she'} fits on the global scale of all tennis players.
                    </p>
                </div>
                <div className={`${styles.linkArea}`}>
                    <form>
                        <div className={`form-group`}>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    id="url"
                                    className="form-control"
                                    value={`${url}`}
                                    ref={this.setInputRef}
                                    readOnly={false}
                                    contentEditable={true}
                                    onChange={() => {
                                        // do nothing
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                    <div
                        className={`btn btn-large ${this.state.displayCopied ? 'btn-default' : 'btn-primary'} d-block text-uppercase`}
                        onClick={() => {
                            if (!this.state.displayCopied) {
                                this.copyTextToClipboard(url);
                            }
                        }}
                    >
                        {this.state.displayCopied ? 'Link Copied' : 'Copy and share invite link'}
                    </div>
                </div>
            </Popup>
        );
    }
}

export default UnClaimedProfileMessagePopup;
